export const TEXT = 'text'
export const BULLET_POINTS = 'bulletPoints'
export const COLORS = 'colors'
export const IMAGE = 'image'
export const VIDEO = 'video'
export const SIZES = 'sizes'
export const PRODUCT = 'product'
export const SHOPIFY_PRODUCT = 'shopifyProduct'
export const IMAGE_LIST = 'imageList'
export const SHOPIFY_VARIANTS = 'shopifyVariants'
export const INSTA_LAYOUT = 'instaLayout'
export const ACTION_BUTTON = 'actionButton'
export const ACTION_BUTTON_W_DESIGN = 'actionButtonWithDesign'
export const ACTION_BUTTON_W_URL = 'actionButtonWithURL'
export const ACTION_BUTTON_W_EMAIL = 'actionButtonWithEmail'
export const EDIT_SOCIAL_URL = 'editSocialUrl'
export const EMAIL_SETTINGS = 'emailSettings'
export const SHARE_BUTTON = 'shareButton'
export const CUSTOM_BUTTON_W_URL = 'customButtonWithUrl'
export const BUTTONS_CONTAINER = 'buttonsContainer'
export const BG = 'bgChange'
export const OPTIONAL_BLOCK = 'optionalBlock'



// WEBPACK FOOTER //
// ./src/constants/customFieldTypes.js